import { InjectionToken } from '@angular/core';

import type { Signal } from '@angular/core';
import type { InputValidationError } from './domain/form.domain';

export type FormAccessibilityScope = 'auto' | 'page' | 'modal';

export interface FormShellStatus {
  readonly pristine: boolean;
  readonly valid: boolean;
  readonly invalid: boolean;
  readonly pending: boolean;
  readonly submissionAttempted: boolean;
  readonly submitting: boolean;
}

/**
 * Model-neutral behavior shared by legacy and Signal Forms shells.
 * Model-specific APIs such as NgForm and FieldTree intentionally stay outside this contract.
 */
export interface FormShell {
  readonly shellStatus: Signal<FormShellStatus>;
  requestSubmit(): void;
  reset(): void;
  setAccessibleError(inputName: string, error?: InputValidationError): void;
  focusFirstError(): void;
}

export const FORM_SHELL = new InjectionToken<FormShell>('FormShell');
